/**
 * Player Pass visual card — matches the PDF aesthetic.
 * Used on the landing page (preview) and on /pass for the user.
 */
export default function PlayerPassCard({
  name = "Your Name Here",
  participantId = "P-XXXXXXXX",
  goal = 10000,
  joined = "—",
  className = "",
  rotate = "rotate-[-2deg]",
}) {
  const initial = (name || "P").slice(0, 1).toUpperCase();
  return (
    <div
      className={`relative w-full max-w-[440px] aspect-[1.58/1] ${className}`}
      data-testid="player-pass-card"
    >
      <div className={`absolute inset-0 ${rotate} transition-transform`}>
        <div className="absolute inset-0 bg-ink translate-x-2 translate-y-2" />
        <div className="absolute inset-0 bg-cream border-2 border-ink overflow-hidden">
          {/* yellow header */}
          <div className="absolute top-0 left-0 right-0 h-[22%] bg-marker-yellow border-b-2 border-ink px-4 flex items-center">
            <div className="font-display font-extrabold text-2xl tracking-tight leading-none">
              <span className="text-marker-red">#</span>NoJobNoVC
            </div>
            <div className="ml-auto font-mono text-[10px] uppercase tracking-widest">
              Official Player Pass
            </div>
          </div>

          {/* approved stamp */}
          <div className="absolute right-3 top-[20%] -translate-y-1/2 rotate-[-9deg] bg-marker-red text-white border-2 border-ink px-3 py-1 shadow-brutal-sm">
            <div className="font-display font-extrabold text-sm leading-none">APPROVED</div>
            <div className="font-mono text-[8px] tracking-widest text-center">EST. 2026</div>
          </div>

          {/* body */}
          <div className="absolute left-4 right-[40%] top-[26%] space-y-2">
            <div>
              <div className="font-mono text-[9px] uppercase tracking-widest text-ink/60">Player</div>
              <div className="font-display font-extrabold text-2xl uppercase tracking-tight leading-tight truncate">
                {name}
              </div>
            </div>
            <div>
              <div className="font-mono text-[9px] uppercase tracking-widest text-ink/60">Participant ID</div>
              <div className="font-mono font-bold text-base">{participantId}</div>
            </div>
            <div>
              <div className="font-mono text-[9px] uppercase tracking-widest text-ink/60">Target</div>
              <div className="font-display font-extrabold text-xl">${Number(goal || 0).toLocaleString()}</div>
            </div>
          </div>

          {/* avatar block */}
          <div className="absolute right-3 bottom-3 w-[34%] aspect-square bg-marker-blue border-2 border-ink flex items-center justify-center text-white font-display font-extrabold text-5xl shadow-brutal-sm">
            {initial}
          </div>

          {/* barcode */}
          <div className="absolute bottom-3 left-4 right-[40%] h-6 flex items-end gap-px">
            {Array.from({ length: 38 }).map((_, i) => {
              const w = (i % 5 === 0 ? 3 : i % 3 === 0 ? 2 : 1);
              return <span key={i} className="bg-ink" style={{ width: `${w}px`, height: `${10 + ((i * 7) % 14)}px` }} />;
            })}
          </div>
          <div className="absolute bottom-1 left-4 right-[40%] font-mono text-[9px] tracking-widest text-ink/70">
            {participantId} / NJNV-2026
          </div>
        </div>
      </div>
    </div>
  );
}
